export default {
    namespaced: true,

    state: {
        loading: false,
        sort: {
            id: 'asc',
        },
        paginate: {
            total: 0,
            current_page: 1,
            per_page: 25,
            last_page: 1,
            from: 0,
            to: 0,
        },
        users: {},
    },

    getters: {
        all: state => () => state.users,

        sorted: state => () => Object.values(state.users),

        pageMeta: state => ({
            total: state.paginate.total,
            current_page: state.paginate.current_page,
            per_page: state.paginate.per_page,
            last_page: state.paginate.last_page,
            from: state.paginate.from,
            to: state.paginate.to,
        }),

        isLoading: state => state.loading,

        pagination: state => ({
            page: state.paginate.current_page,
            per_page: state.paginate.per_page,
        }),

        queryBuilderSorting(state) {
            const sorts = state.sort;
            return Object.keys(sorts).map(key => {
                return sorts[key].toLowerCase() === 'desc' ? `-${key}` : key;
            });
        },
    },

    actions: {
        clearSort({ commit }) {
            commit('CLEAR_SORT');
        },

        sort({ commit }, sortConfig) {
            commit('SET_SORT', sortConfig);
        },

        updatePageParams({ commit }, { page }) {
            commit('SET_PAGE', page);
        },

        paginateAndFetch({ dispatch, rootGetters }) {
            const allData = [
                { id: 1, name: 'John Doe', email: 'john@example.com', status: 'active' },
                { id: 2, name: 'Jane Smith', email: 'jane@example.com', status: 'inactive' },
                { id: 3, name: 'Bob Johnson', email: 'bob@example.com', status: 'active' },
                { id: 4, name: 'Alice Williams', email: 'alice@example.com', status: 'active' },
                { id: 5, name: 'Charlie Brown', email: 'charlie@example.com', status: 'inactive' },
                { id: 6, name: 'Diana Prince', email: 'diana@example.com', status: 'active' },
                { id: 7, name: 'Ethan Hunt', email: 'ethan@example.com', status: 'active' },
                { id: 8, name: 'Fiona Gallagher', email: 'fiona@example.com', status: 'inactive' },
                { id: 9, name: 'George Wilson', email: 'george@example.com', status: 'active' },
                { id: 10, name: 'Helen Troy', email: 'helen@example.com', status: 'active' },
                { id: 11, name: 'Ian Malcolm', email: 'ian@example.com', status: 'inactive' },
                { id: 12, name: 'Jessica Jones', email: 'jessica@example.com', status: 'active' },
            ];

            let filteredData = allData;
            const searchQuery = rootGetters['PlaygroundUsersView/searchQuery'];

            if (searchQuery && searchQuery.length > 0) {
                const query = searchQuery.toLowerCase();
                filteredData = allData.filter(user => {
                    return (
                        user.name.toLowerCase().includes(query) ||
                        user.email.toLowerCase().includes(query) ||
                        user.status.toLowerCase().includes(query)
                    );
                });
            }

            return dispatch('hydrate', filteredData);
        },

        hydrate({ commit }, data) {
            commit('SET_LOADING', true);
            const users = {};
            data.forEach(user => {
                users[user.id] = user;
            });
            commit('SET_USERS', users);

            const perPage = 25;
            const currentPage = 1;
            const total = data.length;
            commit('UPDATE_PAGE_META', {
                total,
                current_page: currentPage,
                per_page: perPage,
                last_page: Math.ceil(total / perPage),
                from: total === 0 ? 0 : (currentPage - 1) * perPage + 1,
                to: Math.min(currentPage * perPage, total),
            });

            commit('SET_LOADING', false);
        },

        updatePageMeta({ commit }, meta) {
            commit('UPDATE_PAGE_META', meta);
        },

        removeChecked({ commit }, checkedRows) {
            return Promise.resolve();
        },
    },

    mutations: {
        SET_LOADING(state, loading) {
            state.loading = loading;
        },

        SET_USERS(state, users) {
            state.users = users;
        },

        UPDATE_PAGE_META(state, meta) {
            state.paginate = { ...state.paginate, ...meta };
        },

        SET_PAGE(state, page) {
            state.paginate.current_page = page;
        },

        CLEAR_SORT(state) {
            state.sort = {};
        },

        SET_SORT(state, sortConfig) {
            state.sort = { ...state.sort, ...sortConfig };
        },
    },
};
